// Ping's tiny Markdown: **bold**, `code`, ```code blocks```, [links](https://…), bare
// https:// links, "- " lists and paragraphs. Everything else is text. Output is built from
// escaped pieces only, and links must be http(s), so a notification can't inject markup.

const esc = (s: string) => s.replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`);

const INLINE = /`([^`\n]+)`|\[([^\]\n]{1,300})\]\((https?:\/\/[^\s)]{1,2000})\)|\*\*([^*\n]+?)\*\*|(https?:\/\/[^\s<>"']*[^\s<>"'.,;:!?)\]])/g;

const link = (href: string, text: string) => `<a href="${esc(href)}" target="_blank" rel="noopener noreferrer nofollow">${text}</a>`;

export function inline(s: string): string {
  let out = "";
  let last = 0;
  for (const m of s.matchAll(INLINE)) {
    out += esc(s.slice(last, m.index));
    if (m[1] !== undefined) out += `<code>${esc(m[1])}</code>`;
    else if (m[2] !== undefined) out += link(m[3]!, esc(m[2]));
    else if (m[4] !== undefined) out += `<strong>${inline(m[4])}</strong>`;
    else out += link(m[5]!, esc(m[5]!));
    last = m.index + m[0].length;
  }
  return out + esc(s.slice(last));
}

function block(text: string): string {
  const lines = text.split("\n");
  if (lines.every((l) => /^\s*[-*•]\s+/.test(l))) return `<ul>${lines.map((l) => `<li>${inline(l.replace(/^\s*[-*•]\s+/, ""))}</li>`).join("")}</ul>`;
  return `<p>${lines.map(inline).join("<br>")}</p>`;
}

export function markdown(src: string): string {
  const parts = src.replace(/\r\n?/g, "\n").split(/```[a-zA-Z0-9_-]*\n?([\s\S]*?)```/);
  return parts
    .map((p, i) =>
      i % 2
        ? `<pre><code>${esc(p.replace(/\n$/, ""))}</code></pre>`
        : p
            .split(/\n{2,}/)
            .map((b) => b.replace(/^\n+|\n+$/g, ""))
            .filter((b) => b.trim())
            .map(block)
            .join(""),
    )
    .join("");
}

/** One line of plain text for the collapsed row: markup removed, whitespace folded. */
export function preview(src: string): string {
  return src
    .replace(/```[a-zA-Z0-9_-]*\n?([\s\S]*?)```/g, "$1")
    .replace(/`([^`\n]+)`/g, "$1")
    .replace(/\*\*([^*\n]+?)\*\*/g, "$1")
    .replace(/\[([^\]\n]+)\]\((https?:\/\/[^\s)]+)\)/g, "$1")
    .replace(/\s+/g, " ")
    .trim();
}
